import { MaskInput } from '@sravni/react-design-system';
import { useIsAppleMobile } from '@sravni/react-utils';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ErrorTextWrapper } from 'shared/ui/ErrorTextWrapper';

import {
  CONFIRMATION_FORM_FIELDS_LABELS_CONFIG,
  CONFIRMATION_FORM_FIELDS,
} from '../PreApprovalConfirmationForm.config';
import type { ConfirmationFormValues } from '../schema';

type Props = {
  name: ValuesOf<typeof CONFIRMATION_FORM_FIELDS>;
  isDisabled?: boolean;
  isLoading?: boolean;
};

export const SmsCodeField = (props: Props) => {
  const { name, isDisabled, isLoading } = props;
  const isAppleMobile = useIsAppleMobile();
  const { control, formState, clearErrors } = useFormContext<ConfirmationFormValues>();
  const { errors } = formState;

  const hasSmsCodeError = Boolean(errors[CONFIRMATION_FORM_FIELDS.SMS_CODE]);

  const errorText = errors[CONFIRMATION_FORM_FIELDS.SMS_CODE]?.message;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, ...field } }) => (
        <ErrorTextWrapper errorText={errorText}>
          <MaskInput
            {...field}
            label={CONFIRMATION_FORM_FIELDS_LABELS_CONFIG[CONFIRMATION_FORM_FIELDS.SMS_CODE]}
            invalid={!!errorText}
            inputMode="decimal"
            autoComplete={isAppleMobile ? 'off' : 'one-time-code'}
            mask="9999"
            disabled={field.disabled || isDisabled}
            loading={isLoading}
            onChange={(value) => {
              if (hasSmsCodeError) {
                clearErrors(CONFIRMATION_FORM_FIELDS.SMS_CODE);
              }
              onChange(value);
            }}
          />
        </ErrorTextWrapper>
      )}
    />
  );
};
